export default {
    company: $localize `Company`,
    individual: $localize `Individual`,
    institution: $localize `Institution`,
    government: $localize `Government institution`,
    non_profit: $localize `Non profit organization`
}